// extracted by mini-css-extract-plugin
module.exports = {"base-grid":"styles_base-grid__hHO_O"};